import { BaseSnapshotModel } from "../BaseSnapshotModel";

export class CommnunicationPreferencesSnapshotModel extends BaseSnapshotModel {
  constructor() {
    super();
    this.Model = {
      modelFields: [
        "allow_general_updates",
        "email_teladoc_health",
        "text_messages_teladoc_health",
        "phone_messages_teladoc_health",
        "personalized_newsletter_condition_management",
        "email_condition_management",
        "text_messages_condition_management",
        "newsletter_and_email_mental_health"
      ],

      requiredFields: []
    };
  }
}
